(()=>{
 if(!document.querySelector('.cfr-purchase'))return;
 const descriptions={
 '53879698751781':'Standard: smart feeding without a camera. Plug-in power with 1200mAh backup.',
 '53879698784549':'Plug-In Camera: live monitoring and two-way audio. Plug-in power with 1200mAh backup.',
 '53879698817317':'Cordless Camera: live monitoring with an 8000mAh rechargeable main battery.'
 };
 function update(event){
 const url=new URL(location.href);url.searchParams.set('view','cutekit-reference');history.replaceState({},'',url);
 const id=String(event?.data?.variant?.id||url.searchParams.get('variant')||'');
 const detail=document.querySelector('.cfr-selected-details');if(detail&&descriptions[id])detail.textContent=descriptions[id];
 }
 if(typeof subscribe==='function')subscribe(PUB_SUB_EVENTS.variantChange,update);update();
 // Preserve Judge.me's actual submit action and populated review display.
 function reviewCopy(){
 const widget=document.querySelector('#judgeme_product_reviews');
 if(!widget)return;
 if(!document.getElementById('customer-reviews')){const anchor=document.createElement('span');anchor.id='customer-reviews';anchor.style.cssText='display:block;scroll-margin-top:90px';widget.before(anchor);}
 if(!widget.querySelector('.jm-no-reviews-state'))return;
 const title=widget.querySelector('.jm-review-widget-minimal-header__title');const body=widget.querySelector('.jm-no-reviews-state__text');
 if(title&&title.textContent!=='Share Your CuteKit Experience')title.textContent='Share Your CuteKit Experience';
 if(body&&body.textContent!=='Be among the first to share your experience with this product.')body.textContent='Be among the first to share your experience with this product.';
 }
 const host=document.querySelector('[id$="__reviews"]');if(host)new MutationObserver(reviewCopy).observe(host,{childList:true,subtree:true});reviewCopy();
})();
